module.exports = __webpack_public_path__ + "img/seagoal-logo.f52559ca.png";